import { create } from "zustand";
import { persist } from "zustand/middleware";

interface FlowCustomer {
  flowId: string;
  customerId: string;
}
interface FlowUser {
  flowId: string;
  userId: string;
}
interface ICustomerStore {
  customerIds: FlowCustomer[];
  userIds: FlowUser[];
  setCustomerId(flowId: string, customerId: string | undefined): void;
  setUserId(flowId: string, userId: string | undefined): void;
}

export const useCustomerStore = create<ICustomerStore>()(persist((set) => ({
  setCustomerId: (flowId: string, newCustomerId: string) => set((state) => {
    if (state.customerIds.find((ci) => ci.flowId === flowId)) {
      return ({
        ...state,
        customerIds: state.customerIds
          .map((ci) => (ci.flowId === flowId ? ({ ...ci, customerId: newCustomerId }) : ci)),
      });
    }
    state.customerIds.push({ flowId, customerId: newCustomerId });
    return {
      ...state,
      customerIds: state.customerIds };
  }),
  setUserId: (flowId: string, newUserId: string) => set((state) => {
    if (state.userIds.find((ci) => ci.flowId === flowId)) {
      return ({
        ...state,
        userIds: state.userIds
          .map((ci) => (ci.flowId === flowId ? ({ ...ci, userId: newUserId }) : ci)),
      });
    }
    state.userIds.push({ flowId, userId: newUserId });
    return {
      ...state,
      userIds: state.userIds };
  }),
  customerIds: [],
  userIds: [],
}), { name: "customer-id" }));

export default useCustomerStore;
